// src/utils/request.js
import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://open.jianqiyue.com/api/v1', // 你的接口基础地址
  timeout: 10000 // 请求超时时间，可根据需要调整
})

// 请求拦截器：统一添加Authorization请求头
service.interceptors.request.use(
  config => {
    // 从localStorage中获取access_token
    const token = localStorage.getItem('access_token')
    // 只有没手动传Authorization时，才自动加（兼容特殊接口）
    if (token && !config.headers['Authorization']) {
      config.headers['Authorization'] = token
    }
    return config
  },
  error => {
    // 请求错误处理
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器：统一处理响应和错误（新增自定义响应处理逻辑）
service.interceptors.response.use(
  response => {
    // 如果传了customResponseHandle，就走自定义逻辑，否则返回data（兼容原有接口）
    if (response.config.customResponseHandle) {
      return response
    }
    return response.data
  },
  error => {
    console.warn('统计上报失败：', error.message)
    return Promise.resolve(null)
  }
)

// 封装GET请求（新增config参数）
export function get(url, params, config = {}) {
  return service({
    method: 'get',
    url,
    params,
    ...config // 合并自定义配置
  })
}

// 封装POST请求（新增config参数）
export function post(url, data, config = {}) {
  return service({
    method: 'post',
    url,
    data,
    ...config // 合并自定义配置
  })
}